import React from "react";
import BlogSixteen from "../component/BlogSixteen";

function BlogSixteenContainer() {
  return <BlogSixteen />;
}
export default BlogSixteenContainer;
